module.exports = __webpack_public_path__ + "static/media/icon-filetype-attachments.9ca237d0.svg";